<div class="search-field">
  <input pInputText type="text" class="search-field-input" [placeholder]="'button.search' | translate"
    [(ngModel)]="value" (ngModelChange)="filter()" />
  <span class="pi pi-search search-field-icon"></span>
</div>
